<script>
  import { linkResolver } from "$lib/prismic";
  import Headlines from "./Headlines.svelte";
  import Image from "$lib/Image.svelte";
  import Text from "$lib/Text.svelte";
  export let block;
</script>

<div
  class="py-16 {block.primary.background ? 'dark' : 'light'}"
  class:pattern={block.primary.pattern}
>
  <div class="max-w-content mx-auto">
    <div class="flex flex-wrap -my-8 xl:-m-8 items-stretch">
      <div
        class="w-full lg:w-1/2 flex-grow p-8 {block.primary.reverse
          ? 'lg:order-2'
          : ''}"
      >
        <Headlines
          headlines={{
            headline: block.primary.headline?.[0],
            subline: block.primary.subline?.[0],
          }}
          pink={block.primary.background}
          large={true}
        />
        {#if block.primary.text}
          <div class="mt-8 max-w-5xl" class:fancylist={block.primary.fancylist}>
            <Text text={block.primary.text} />
          </div>
        {/if}
        {#if block.fields}
          {#each block.fields as { link, link_text }, index}
            {#if link}
              <a
                class="btn mt-8 mr-4"
                data-text={link_text || link.name || link.title[0].text}
                href={link.url || linkResolver(link._meta)}
                target={link.target}
                >{link_text || link.name || link.title[0].text}</a
              >
            {/if}
          {/each}
        {/if}
        <slot />
      </div>
      {#if block.primary.image}
        <div
          class="w-full lg:w-1/2 p-8 flex-col relative  {block.primary.reverse
            ? 'lg:order-1'
            : ''}"
        >
          <Image image={block.primary.image} />
        </div>
      {/if}
    </div>
  </div>
</div>
